import { ReadonlyDetail } from '@/common/components/employees/shared/ReadonlyDetail';
import { useEmployeeDetailContext } from '@/common/contexts/EmployeeDetailContext';
import { EmployeeMaritalStatusLabels } from '@/common/types';

export const SocialInsuranceDetails = () => {
  const { employeeDetail } = useEmployeeDetailContext();

  return (
    <div className="mb-6">
      <div className="mb-4 font-semibold">Social Insurance</div>
      <fieldset className="form-fieldset">
        <ReadonlyDetail label="Social Insurance Type">{employeeDetail.personalInformation.taxCode}</ReadonlyDetail>

        <ReadonlyDetail label="Social Insurance Number">
          {employeeDetail.personalInformation.socialInsuranceNumber}
        </ReadonlyDetail>

        <ReadonlyDetail label="Pension voluntary contribution rate">
          {employeeDetail.personalInformation.pensionVoluntaryContributionRate}
        </ReadonlyDetail>

        <ReadonlyDetail label="Tax withholding rate">
          {employeeDetail.personalInformation.taxWithholdingRate}
        </ReadonlyDetail>

        <ReadonlyDetail label="Notes">{employeeDetail.personalInformation.socialInsuranceNotes}</ReadonlyDetail>

        <ReadonlyDetail label="Marital Status">
          {employeeDetail.personalInformation.maritalStatus
            ? EmployeeMaritalStatusLabels[employeeDetail.personalInformation.maritalStatus]
            : null}
        </ReadonlyDetail>
      </fieldset>
    </div>
  );
};
